import React from 'react'
import { Card, Heading2, FlagWrapper, FlagBody, FlagComponent } from '@sainsburys-tech/luna-react'
import Section from 'src/components/Section'
import Table from 'src/components/Table'
import { Link } from 'react-router-dom'
import { CREATE_CATEGORIES } from 'src/constants/permissions'
import WithRequiredPermissions from 'src/components/WithRequiredPermissions'
import columns from './columns'
import { selectCategories } from './store'

const Categories = () => (
  <Section>
    <FlagWrapper>
      <FlagBody>
        <Heading2 className="ln-u-soft-right" data-control="category-title">
          Categories
        </Heading2>
      </FlagBody>
      <FlagComponent alignment="top" nowrap>
        <WithRequiredPermissions permission={CREATE_CATEGORIES}>
          <Link className="ln-c-button ln-c-button--outlined" to="/categories/create">
            Create
          </Link>
        </WithRequiredPermissions>
      </FlagComponent>
    </FlagWrapper>
    <Card>
      <Table type="categories" searchEnabled columns={columns} dataSelector={selectCategories} />
    </Card>
  </Section>
)

export default Categories
